<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">

        <!-- PAGE HEADER -->
        <reports-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :search_data="searchform"
          :columns="originalColumn"
          :hasExportPermission="hasExportPermission"
        />

        <!-- TEAM AVAILABILITY PAGE -->
        <div class="row mt-4">
          <div class="col-md-12">
            <div class="timeline-wrapper">

              <!-- HEADER -->
              <div class="timeline-header">
                <div>
                  <div class="timeline-title">Leave Calendar</div>
                  <div class="timeline-subtitle">{{ formattedRange }}</div>
                </div>

                <div class="timeline-header-right">
                  <div class="legend">
                    <div class="legend-item">
                      <span class="legend-dot legend-dot--leave"></span>
                      <span class="legend-text">Leave</span>
                    </div>
                  </div>

                  <div class="total-off">
                    <div class="total-label">Total Days Off</div>
                    <div class="total-value">{{ totalDaysOff }}</div>
                  </div>
                  
                  <!-- Pagination Controls -->
                  <div class="pagination-controls" v-if="totalItems > filters.perPage">
                    <button 
                      class="pagination-btn" 
                      :disabled="filters.page <= 1"
                      @click="changePage(filters.page - 1)"
                    >
                      &laquo; Prev
                    </button>
                    <span class="page-info">
                      Page {{ filters.page }} of {{ Math.ceil(totalItems / filters.perPage) }}
                    </span>
                    <button 
                      class="pagination-btn" 
                      :disabled="filters.page >= Math.ceil(totalItems / filters.perPage)"
                      @click="changePage(filters.page + 1)"
                    >
                      Next &raquo;
                    </button>
                  </div>
                </div>
              </div>

              <!-- FILTER BAR -->
              <div class="filters-bar">

                <div class="col-sm-6 col-md-2">
                  <div class="input-block mb-3 form-focus focused">
                    <div class="cal-icon">
                      <datepicker
                        v-model="filters.start"
                        placeholder="Choose Date"
                        class="form-control floating datetimepicker"
                        :editable="true"
                        :clearable="false"
                        :input-format="dateFormat"
                        @update:model-value="updateDateRange"
                      />
                      <label class="focus-label">Start Date</label>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 col-md-2">
                  <div class="input-block mb-3 form-focus focused">
                    <div class="cal-icon">
                      <datepicker
                        v-model="filters.end"
                        placeholder="Choose Date"
                        class="form-control floating datetimepicker"
                        :editable="true"
                        :clearable="false"
                        :input-format="dateFormat"
                        @update:model-value="updateDateRange"
                      />
                      <label class="focus-label">End Date</label>
                    </div>
                  </div>
                </div>

                <!-- SEARCH -->
                <div class="col-sm-6 col-md-2">
                  <div class="input-block mb-2 form-focus focused">
                    <!--
					<input
                      type="text"
                      class="form-control floating"
                      v-model="filters.search"
                      placeholder="Search employee"
                      @input="applyFilters"
                    /> -->
					 <vue-select
						  :options="employee_list"
						  id="projectreportname"
						  v-model="filters.search"
						  placeholder="-"
						  @update:modelValue="applyFilters"
					  />
						<label class="focus-label">Employee Name</label>
				
                  </div>
                </div>

                <!-- LEAVE TYPE FILTER -->
                <div class="col-sm-6 col-md-2">
                  <div class="input-block mb-2 form-focus focused">
                    <vue-select
                      :options="leaveTypes"
                      v-model="filters.leaveType"
                      placeholder="-"
                      @update:modelValue="applyFilters"
                    />
                    <label class="focus-label">Select Leave Type</label>
                  </div>
                </div>

              </div>

              <!-- SCHEDULER -->
              <div class="calendar-shell">
                <FullCalendar ref="calendar" :options="calendarOptions" />
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>



<script>
import axios from "axios";
import { notification } from "ant-design-vue";
import FullCalendar from "@fullcalendar/vue3";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";

export default {
  components: { FullCalendar },

  data() {
    const current = new Date();
    const last7 = new Date();
    last7.setDate(current.getDate() - 6);

    return {
      title: "Leave Calendar",
      path: "Dashboard",
      text: "Leave Calendar",
      text1: "Export Excel",
	  employee_list: [],	
	  defaultAvatar: "avatar-01.jpg",
      dateFormat: "dd-MM-yyyy",

      filters: {
        start: last7,
        end: current,
        search: "",
        leaveType: "",
        page: 1,
        perPage: 10
      },

      apiEmployees: [],
      leaveTypes: [],
      totalItems: 0,

      resources: [],
      events: [],

      calendarOptions: {
        plugins: [resourceTimelinePlugin, interactionPlugin],
        initialView: "resourceTimeline",
        schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
        height: "auto",
        stickyHeaderDates: true,
        nowIndicator: false,
        selectable: false,
        editable: false,
        eventStartEditable: false,
        eventDurationEditable: false,

        headerToolbar: false,

        views: {
          resourceTimeline: {
            type: "resourceTimeline",
            slotDuration: { days: 1 },
            slotLabelFormat: [
              { month: "short", year: "numeric" },
              { weekday: "short", day: "2-digit" },
            ],
            slotMinWidth: 90,
			slotLaneHeight: 56
          },
        },

        initialDate: this.formatDate(last7),
        visibleRange: {
          start: this.formatDate(last7),
          end: this.addOneDay(this.formatDate(current)),
        },

        resourceAreaWidth: "280px",
        resourceOrder: "title",
        resources: [],
        events: [],

        resourceAreaHeaderContent: "Employees",

        resourceLabelContent: (arg) => {
          const r = arg.resource.extendedProps || {};
          if (arg.resource.id === "empty") {
            return { html: `<div class=\"empty-resource\">No records found</div>` };
          }

          const avatar = r.avatar || "";
          const role = r.role || "";
          const title = arg.resource.title || "";
          return {
            html: `
              <div class=\"resource-cell\">
                <div class=\"resource-avatar\">${avatar ? `<img src=\"${avatar}\" class=\"emp-avatar\" />` : ""}</div>
                <div class=\"resource-meta\">
                  <div class=\"emp-name\">${title}</div>
                  <div class=\"emp-role\">${role}</div>
                </div>
              </div>
            `,
          };
        },

        eventContent: (arg) => {
          const leaveCode = arg.event.extendedProps.leaveCode || "";
          const type = arg.event.extendedProps.type || "";
          const title = `${leaveCode} - ${type}`.trim();
          return { html: `<div class=\"leave-event\">${title}</div>` };
        },
      },
    };
  },

  computed: {
    formattedRange() {
      return `${this.formatDate(this.filters.start)} - ${this.formatDate(this.filters.end)}`;
    },
    totalDaysOff() {
      return this.events.length;
    }
  },

  mounted() {
	this.loadAllLeavetype([]);
	this.loadAllEmployees([]);
	
    this.fetchLeaveCalendar();
  },

  beforeUnmount() {
  },

  methods: {
    changePage(newPage) {
      if (newPage >= 1 && newPage <= Math.ceil(this.totalItems / this.filters.perPage)) {
        this.filters.page = newPage;
        this.fetchLeaveCalendar();
        // Scroll to top of calendar when changing pages
        const calendarEl = document.querySelector('.fc-view-harness');
        if (calendarEl) {
          calendarEl.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
	getCalendarApi() {
		return this.$refs.calendar?.getApi ? this.$refs.calendar.getApi() : null;
	},
	applyCalendarRange() {
		const api = this.getCalendarApi();
		if (!api) return;

		const start = this.formatDate(this.filters.start);
		const endExclusive = this.addOneDay(this.formatDate(this.filters.end));

		api.setOption("visibleRange", { start, end: endExclusive });
		api.gotoDate(start);
	},
	getEmployeeAvatar(avatar) {
	  if (!avatar) {
		return require(`@/assets/img/profiles/${this.defaultAvatar}`);
	  }

	  if (avatar.startsWith("http")) {
		return avatar;
	  }

	  return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
	},
	loadAllEmployees(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/employees/allemployees", params)
        .then((response) => {
          //	console.log(response.data.data.data);

          //this.employee_list = response.data.data;

          console.log(response.data.data);

          for (let i = 0; i < response.data.data.length; i++) {
            this.employee_list.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    /* ------------------ FORMAT DATE ------------------ */
    formatDate(d) {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
	loadAllLeavetype(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/leave-definition/all", params)
        .then((response) => {
		
		  for (let i = 0; i < response.data.data.length; i++) {
            this.leaveTypes.push({
              id: response.data.data[i].id,
              text: response.data.data[i].name,
            });
          }
		  

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    addOneDay(dateStr) {
      const d = new Date(dateStr);
      d.setDate(d.getDate() + 1);
      return this.formatDate(d);   // FIXED (no timezone shift)
    },

    /* ------------------ FETCH API ------------------ */
    fetchLeaveCalendar() {
      const token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/teamavailability/leavecalendar", {
          params: {
            start_date: this.formatDate(this.filters.start),
            end_date: this.formatDate(this.filters.end),
            page: this.filters.page,
            per_page: this.filters.perPage
          }
        })
        .then(response => {
          const users = response.data.data.data ?? [];
          const pagination = response.data.data.meta?.pagination;
          
          this.apiEmployees = users;
          this.buildResourcesFromAPI(users, pagination);
          this.buildEventsFromAPI(users);
          this.applyCalendarRange();

          loader.hide();
        })
        .catch(err => {
          loader.hide();
          console.error("API Error:", err);
          notification.error({
            message: 'Error',
            description: 'Failed to fetch leave calendar data',
            placement: 'topRight'
          });
        });
    },

    /* ------------------ BUILD RESOURCES ------------------ */
    buildResourcesFromAPI(users, pagination = null) {
      if (!users.length) {
        this.resources = [
          { id: "empty", title: "No records found", avatar: "", role: "" }
        ];
        this.calendarOptions.resources = this.resources;
        return;
      }

      this.resources = users.map(u => ({
        id: String(u.id),
        title: u.first_name + " " + u.last_name,
        avatar: this.getEmployeeAvatar(u.avatar),
        role: u.department?.name || "",
      }));

      // Update pagination if provided
      if (pagination) {
        this.totalItems = pagination.total;
      }

      this.calendarOptions.resources = this.resources.map(r => ({
        id: r.id,
        title: r.title,
        extendedProps: {
          avatar: r.avatar,
          role: r.role,
        },
      }));
    },

    /* ------------------ BUILD EVENTS (UPDATED) ------------------ */
    buildEventsFromAPI(users) {
	  if (!users.length) {
		this.events = [];
		this.calendarOptions.events = [];
		return;
	  }

	  const events = [];

	  users.forEach((user) => {
		const empId = String(user.id);
		const approved = user.user_approved_leaves || [];

		approved.forEach((leave) => {
			const details = leave.leavedetails || [];
			details.forEach((detail, index) => {
				const date = detail.leave_details_date;
				if (!date) return;

				events.push({
					id: `${empId}-${leave.id}-${index}`,
					resourceId: empId,
					start: date,
					end: this.addOneDay(date),
					allDay: true,
					type: detail.leave_details_type,
					leaveTypeId: leave.leave_type_id,
					leaveCode: leave.leave_type?.code || "",
					backgroundColor: "#F44336",
					borderColor: "#F44336",
				});
			});
		});
	  });

	  this.events = events;
	  this.calendarOptions.events = events.map((e) => ({
		id: e.id,
		title: "",
		start: e.start,
		end: e.end,
		allDay: true,
		resourceId: e.resourceId,
		backgroundColor: e.backgroundColor,
		borderColor: e.borderColor,
		extendedProps: {
			type: e.type,
			leaveTypeId: e.leaveTypeId,
			leaveCode: e.leaveCode,
		},
	  }));
	},

    /* ------------------ DATE RANGE CHANGE ------------------ */
    updateDateRange() {
      let start = new Date(this.filters.start);
      let end = new Date(this.filters.end);

      this.filters.start = start;
      this.filters.end = end;

      this.fetchLeaveCalendar();
    },

    /* ------------------ FILTERING ------------------ */
    applyFilters() {
	  let users = [...this.apiEmployees];

	  /* A) EMPLOYEE FILTER (BY ID) */
	  if (this.filters.search) {
		const selected = this.filters.search;
		const selectedId =
		  typeof selected === "object" ? selected.id : selected;

		users = users.filter(u => String(u.id) === String(selectedId));
	  }

	  /* B) BUILD RESOURCES + EVENTS */
	  this.buildResourcesFromAPI(users);
	  this.buildEventsFromAPI(users);

	  if (!users.length) {
		this.events = [];
		this.calendarOptions.events = [];
		return;
	  }

	  let events = [...this.events];

	  /* C) LEAVE TYPE FILTER */
	  if (this.filters.leaveType) {
		const selected = this.filters.leaveType;
		const selectedId =
		  typeof selected === "object" ? selected.id : selected;

		events = events.filter(
		  e => String(e.leaveTypeId) === String(selectedId)
		);
	  }

	  /* D) APPLY RESULT */
	  this.events = events;
	  this.calendarOptions.events = events.map(e => ({
		id: e.id,
		title: "",
		start: e.start,
		end: e.end,
		allDay: true,
		resourceId: e.resourceId,
		backgroundColor: e.backgroundColor,
		borderColor: e.borderColor,
		extendedProps: {
			type: e.type,
			leaveTypeId: e.leaveTypeId,
			leaveCode: e.leaveCode,
		},
	  }));
	}


  }
};
</script>




<style scoped>
/* SAME CSS YOU ALREADY HAVE */

.timeline-wrapper {
  background: #fff;
  padding: 15px;
}


/* INNER HEADER */
.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.timeline-title {
  font-size: 18px;
  font-weight: 700;
}

.timeline-subtitle {
  font-size: 13px;
  color: #777;
  margin-top: 2px;
}

.timeline-header-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  row-gap: 10px;
  justify-content: flex-end;
  margin-left: auto;
  max-width: 70%;
}

 .legend {
  display: flex;
  align-items: center;
  gap: 10px;
 }

 .legend-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f8f9fa;
  border: 1px solid #eef1f4;
  padding: 6px 10px;
  border-radius: 999px;
 }

 .legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  display: inline-block;
 }

 .legend-dot--leave {
  background: #F44336;
 }

 .legend-text {
  font-size: 12px;
  font-weight: 600;
  color: #444;
 }

.pill-btn {
  border-radius: 999px;
  padding: 5px 14px;
  border: 1px solid #d0d0d0;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
}

.pill-active {
  background: #1e88e5;
  color: #fff;
  border-color: #1e88e5;
}

.filter-select {
  border-radius: 999px;
  border: 1px solid #d0d0d0;
  padding: 4px 10px;
  font-size: 12px;
  background: #fff;
}

.total-off {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 6px 12px;
  min-width: 110px;
  text-align: center;
  white-space: nowrap;
}

.total-label {
  font-size: 11px;
  color: #666;
}

.total-value {
  font-size: 16px;
  font-weight: 700;
}

/* EMPLOYEE COLUMN */

.scheduler_default_rowheader {
  min-height: 160px !important;
}

/* FLOATING SUMMARY BOX */
.floating-box {
  position: absolute;
  right: 25px;
  top: 82px;
  background: #fff;
  padding: 16px 18px;
  border-radius: 12px;
  width: 260px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
}

.floating-box h4 {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 700;
}

.floating-box ul {
  margin: 0;
  padding-left: 18px;
}

.floating-box li {
  font-size: 13px;
  margin-bottom: 6px;
}

/* GRID CLEANUP */
.scheduler_default_corner_inner,
.scheduler_default_rowheader_inner,
.scheduler_default_timeheader_inner {
  background: #ffffff !important;
}

.scheduler_default_timeheader_cell {
  font-size: 13px !important;
  color: #444 !important;
}

.scheduler_default_timeheader_cell:not(:first-child) {
  border-left: 1px solid #e6e6e6;
}

.scheduler_default_cell {
  background: #ffffff !important;
  border-right: 1px solid #e6e6e6 !important;
  border-bottom: 1px solid #e6e6e6 !important;
}

.filters-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.search-input {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  width: 200px;
}

.selector {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.emp-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

 .calendar-shell {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
 }

 :deep(.fc) {
  font-family: inherit;
 }

 :deep(.fc .fc-toolbar) {
  padding: 10px 12px;
  border-bottom: 1px solid #eef1f4;
  margin-bottom: 0;
 }

 :deep(.fc .fc-toolbar-title) {
  font-size: 14px;
  font-weight: 700;
 }

 :deep(.fc .fc-button) {
  border-radius: 8px;
 }

 :deep(.fc-theme-standard td, .fc-theme-standard th) {
  border-color: #eef1f4;
 }



/* Pagination Styles */
.pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 20px;
}

.pagination-btn {
  padding: 6px 12px;
  border: 1px solid #d9d9d9;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-btn:not(:disabled):hover {
  background: #f0f0f0;
  border-color: #bfbfbf;
}

.page-info {
  font-size: 12px;
  color: #666;
  min-width: 100px;
  text-align: center;
}


 .leave-event {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
 }

 .empty-resource {
  color: #999;
  font-weight: 600;
  padding: 10px 0;
 }
 
 .resource-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 6px;
}

.resource-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.emp-name {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  line-height: 1.2;
}

.emp-role {
  font-size: 12px;
  color: #777;
  margin-top: 2px;
}


:deep(.resource-avatar) {
  width: 44px;
  height: 44px;
  min-width: 44px;
  border-radius: 50%;
  overflow: hidden;
  background: #e9ecef;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.emp-avatar) {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

:deep(.resource-cell) {
  display: flex;
  align-items: center;        /* vertical center */
  gap: 12px;
  padding: 8px 10px;
}

:deep(.resource-meta) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

:deep(.emp-name) {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  line-height: 1.2;
  white-space: nowrap;
}

:deep(.emp-role) {
  font-size: 12px;
  color: #777;
  margin-top: 2px;
  white-space: nowrap;
}

/* SAME height for both resource + timeline */
:deep(.fc-resource),
:deep(.fc-timeline-lane) {
  height: 48px !important;
  min-height: 48px !important;
}

:deep(.fc-datagrid-cell),
:deep(.fc-datagrid-cell-frame) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}



/* Align Employees header with rows */
:deep(.fc-col-header-cell-cushion) {
  padding-left: 12px;
  font-weight: 600;
}

/* Center resource content vertically */


:deep(.leave-event) {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  border-radius: 0 !important;
}

:deep(.fc-timeline-lane-frame) {
  padding: 0 !important;
}



/* Event wrapper fills full row */
:deep(.fc-timeline-event) {
  height: 100% !important;
  margin: 0 !important;
  border-radius: 0 !important;
  display: flex;
  align-items: stretch;
}

/* ✅ FINAL: perfectly align Employees column with timeline rows */
:deep(.fc-datagrid-cell-frame) {
  height: 100%;
  display: flex;
  align-items: center;     /* vertical center */
}


/* Allow dropdowns to float over FullCalendar */
:deep(.fc-view-harness),
:deep(.fc-scroller),
:deep(.fc-scroller-liquid-absolute) {
  overflow: visible !important;
  z-index: 1 !important;
}


</style>
